module.exports = __webpack_public_path__ + "static/media/instagram.49b01304.svg";